import { useState } from "react";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/urlEnum";
import { GenericTemplatesType, isEmpty, replaceMacro } from "../../Utils/utils";

export const useDescriptionTemplates = ({
  cacheContext,
  vehicleContext,
  setValue,
  getValues,
}: any) => {
  const [descriptionTemplates, setDescriptionTemplates] = useState<any[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);

  function getDescriptionTemplates() {
    getData(`${urlEnum.genericTemplates}/type/${GenericTemplatesType[1]}`).then(
      (response: any) => {
        const templates: any[] = [];
        response?.data?.templates?.forEach((template: any) => {
          templates.push({
            id: template.id,
            templateName: template.templateName,
            html: template.html,
          });
        });
        setDescriptionTemplates(templates);
        if (isEmpty(vehicleContext.state?.vehicle?.descriere)) {
          if (vehicleContext.state?.vehicle?.id && vehicleContext.state?.vehicle?.id !== 0) {
            const template = templates.length > 1 ? templates[1] : templates[0];
            setSelectedTemplate(template);
            setValue(
              "descriere",
              templates.length > 0
                ? replaceMacro(template.html, vehicleContext.state.vehicle, cacheContext.cache)
                : "",
            );
            const vehicle = vehicleContext.state.vehicle;
            vehicle.descriere = getValues("descriere");
            vehicleContext.updateVehicle(vehicle);
          }
        }
      },
    );
  }

  return { descriptionTemplates, selectedTemplate, setSelectedTemplate, getDescriptionTemplates };
};

export default useDescriptionTemplates;
